import { Clock, Moon, Repeat, TrendingDown } from "lucide-react";

const STATS = [
  { icon: Clock, big: "78%", tail: "buy from first responder", sub: "AI replies in 8s", gain: "3× leads" },
  { icon: Moon, big: "60%", tail: "inquiries after hours", sub: "Agents never sleep", gain: "+42% bookings" },
  { icon: Repeat, big: "3hrs", tail: "wasted on repeats", sub: "WhatsApp autopilot", gain: "60hrs/mo saved" },
  { icon: TrendingDown, big: "₹0", tail: "ROI visibility", sub: "Live dashboard", gain: "-40% CPL" },
];

export default function FrictionBar() {
  return (
    <section className="relative py-14 sm:py-20 border-y border-[var(--yg-border)] bg-[rgba(11,11,20,0.5)]" data-testid="friction-bar">
      <div className="absolute inset-0 yg-grid-strip opacity-40" aria-hidden />
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8 relative">
        <div className="mb-8 sm:mb-10 max-w-[520px]">
          <span className="yg-eyebrow">// The math</span>
          <h2 className="yg-h2 text-[clamp(26px,3.6vw,40px)] mt-2 text-white">
            Every minute costs you.
          </h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          {STATS.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.big}
                className="yg-card yg-card-hover p-4 sm:p-5 min-h-[168px] flex flex-col justify-between"
                data-testid={`friction-stat-${i}`}
                style={{ animation: `yg-rise 700ms ${i * 90}ms both cubic-bezier(.2,.9,.3,1)` }}
              >
                <Icon className="w-5 h-5 text-[var(--yg-violet-light)]" />
                <div>
                  <div className="text-white yg-display text-[clamp(32px,4.2vw,44px)] leading-none yg-tick">{s.big}</div>
                  <div className="text-[12px] text-[var(--yg-text-mute)] mt-2 leading-snug">{s.tail}</div>
                </div>
                <div className="pt-3 mt-3 border-t border-[var(--yg-border)] flex items-center justify-between">
                  <span className="yg-mono text-[9.5px] tracking-[0.2em] uppercase text-[var(--yg-text-dim)]">{s.sub}</span>
                  <span className="text-[11px] font-semibold text-[var(--yg-green)]">↑ {s.gain}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
